var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 15.0003V14.3337C23.3333 13.4002 23.3333 12.9335 23.1517 12.577C22.9919 12.2634 22.7369 12.0084 22.4233 11.8486C22.0668 11.667 21.6001 11.667 20.6667 11.667H19.3333C18.3999 11.667 17.9332 11.667 17.5767 11.8486C17.2631 12.0084 17.0081 12.2634 16.8483 12.577C16.6667 12.9335 16.6667 13.4002 16.6667 14.3337V15.0003M18.3333 19.5837V23.7503M21.6667 19.5837V23.7503M12.5 15.0003H27.5M25.8333 15.0003V24.3337C25.8333 25.7338 25.8333 26.4339 25.5608 26.9686C25.3212 27.439 24.9387 27.8215 24.4683 28.0612C23.9335 28.3337 23.2335 28.3337 21.8333 28.3337H18.1667C16.7665 28.3337 16.0665 28.3337 15.5317 28.0612C15.0613 27.8215 14.6788 27.439 14.4392 26.9686C14.1667 26.4339 14.1667 25.7338 14.1667 24.3337V15.0003",
    stroke: "#EF6A6C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.461b165cb38ac1af068b92cb466a08a8.svg";
export { ForwardRef as ReactComponent };